import type { ITwoDLayerController } from '@/engine/app/interfaces';
import { action, makeObservable, observable } from 'mobx';

import type { ITwoDViewModel } from '@/engine/UIPresentation/Interfaces';
import { injectable } from 'inversify';
import type { ViewPortTooltipViewModel } from '@/engine/app/models/ViewPortTooltipViewModel';

@injectable()
export class TwoDLayerController implements ITwoDLayerController {
  @observable public twoDViewModels: Array<ITwoDViewModel>;

  @observable public tooltips: Array<ViewPortTooltipViewModel>;

  public constructor() {
    makeObservable(this);
    this.twoDViewModels = [];
    this.tooltips = [];
  }

  @action
  public addViewModel(viewModel: ITwoDViewModel): void {
    this.twoDViewModels.push(viewModel);
  }

  @action
  public removeViewModel(viewModel: ITwoDViewModel): void {
    const indexOfModel = this.twoDViewModels.findIndex((model) => {
      return model === viewModel;
    });
    this.twoDViewModels.splice(indexOfModel, 1);
  }

  @action
  public addTooltip(tooltip: ViewPortTooltipViewModel): void {
    this.tooltips.push(tooltip);
  }

  @action
  public removeTooltip(tooltip: ViewPortTooltipViewModel): void {
    const indexOfTooltip = this.tooltips.findIndex((t) => {
      return t === tooltip;
    });
    this.tooltips.splice(indexOfTooltip, 1);
  }

  @action
  public hideTooltip(tooltip: ViewPortTooltipViewModel): void {
    tooltip.hide();
  }

  @action
  public dispose(): void {
    this.twoDViewModels = [];
    this.tooltips = [];
  }
}
